import { create } from 'zustand';

interface WidgetState {
  fullscreenId: string | null;
  refreshTokens: Record<string, number>; // widget id -> monotonic counter to trigger refresh
  setFullscreen: (id: string | null) => void;
  bumpRefresh: (id: string) => void;
  bumpAll: () => void;
}

export const useWidgetStore = create<WidgetState>((set) => ({
  fullscreenId: null,
  refreshTokens: {},
  setFullscreen: (fullscreenId) => set({ fullscreenId }),
  bumpRefresh: (id) =>
    set((s) => ({ refreshTokens: { ...s.refreshTokens, [id]: (s.refreshTokens[id] ?? 0) + 1 } })),
  bumpAll: () =>
    set((s) => {
      const next: Record<string, number> = {};
      Object.keys(s.refreshTokens).forEach((k) => (next[k] = (s.refreshTokens[k] ?? 0) + 1));
      return { refreshTokens: next };
    }),
}));
